<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" :class="!isDetail && 'isDetail'" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 62 60">
    <g id="yema4" transform="translate(-962 -4)">
      <rect id="矩形_2898" data-name="矩形 2898" width="55" height="55" transform="translate(969 9)" fill="var(--theme-color-1)"/>
      <g id="矩形_2897" data-name="矩形 2897" transform="translate(962 4)" fill="#fff" stroke="var(--theme-color-1)" stroke-width="3">
        <rect width="55" height="55" stroke="none"/>
        <rect x="1.5" y="1.5" width="52" height="52" fill="none"/>
      </g>
      <text id="_01" data-name="01" transform="translate(974 43)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.isDetail {
  position: absolute;
  bottom: 20px;
  right: 10px;
}
</style>
